<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <ApprovalChainTemplateForm
          ref="approvalChainTemplateForm"
          :approvalChainTemplate="approvalChainTemplate"
          @onSubmit="saveTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="validateForm" :loading="isSaving">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { APPROVAL_CHAIN_TEMPLATE_NAMESPACE } from "@/store/modules/organisations/organisation-approval-chain-templates";
import { UPDATE_APPROVAL_CHAIN_TEMPLATE } from "@/store/modules/organisations/organisation-approval-chain-templates/actions";
import ApprovalChainTemplateForm from "@/views/settings/components/approval-chain-templates/components/ApprovalChainTemplateForm";

const { mapActions } = createNamespacedHelpers(
  APPROVAL_CHAIN_TEMPLATE_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean,
    approvalChainTemplate: Object
  },
  components: {
    PrimaryButton,
    DialogFull,
    ApprovalChainTemplateForm
  },
  data() {
    return {
      isSaving: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Edit Approval Chain"
      };
    }
  },
  methods: {
    ...mapActions({
      updateApprovalChain: UPDATE_APPROVAL_CHAIN_TEMPLATE
    }),
    validateForm() {
      this.$refs.approvalChainTemplateForm.validateForm();
    },
    async saveTemplate(approvalChainTemplate) {
      this.isSaving = true;
      await this.updateApprovalChain(approvalChainTemplate);
      this.isSaving = false;
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
